import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export const OPERATOR_QUALITY_METRICS_COMMON_MISTAKES_KEY = 'operator-quality-metrics-common-mistakes'

type QualityMetricsCommonMistakesRequest = {
  start_date?: string
  end_date?: string
  program_id?: string
}

type QualityMetricsCommonMistakesResponse = {
  response: {
    correct: string
    wrong: string
    type: 'object_detection' | 'classification' | 'response'
    subType: string
  }
  count: number
  countTrend?: number
  share: number
  shareTrend?: number
}

export function useGetMineCommonMistakes(params: QualityMetricsCommonMistakesRequest) {
  return useQuery({
    queryKey: [OPERATOR_QUALITY_METRICS_COMMON_MISTAKES_KEY, params],
    queryFn: async () =>
      (
        await apiClient.get<QualityMetricsCommonMistakesResponse[]>(
          `/int/metrics/quality/operators/common-mistakes/mine`,
          {
            params: {
              start_date: params.start_date,
              end_date: params.end_date,
              program_id: params.program_id,
            },
          }
        )
      ).data,
    enabled: Boolean(params.program_id) && Boolean(params.start_date) && Boolean(params.end_date),
    refetchOnWindowFocus: false,
  })
}
